import '../assets/styles/footer.css';
import '../App.css'
import React from 'react';

function ShowFooter() {
    return (
        <div className="footer">
            <div className="footer-content">
                <div className="footer-left">
                    <span>&copy; 2025 The Yoruba Dictionary At Yale</span>
                </div>
                <div className="footer-right">
                    <p>Designed by <a className='task-link' href="https://muy31.github.io/" target='blank'>Muyi Aghedo</a></p>
                </div>
            </div>
        </div>
    );
}

export default ShowFooter;